module.exports = __webpack_public_path__ + "media/images/emblems/La_Punt-Chamues-ch_wappen-be8acad49bd63bbeabb47cf71c2fdfec.svg";